import React, { useState, useEffect } from "react";
import { useField } from "formik";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import { ptBR } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";

export default function DatePickerField(props) {
  const [field, meta, helper] = useField(props);
  const { touched, error } = meta;
  const { setValue } = helper;
  const isError = touched && error && true;
  const { value } = field;
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      setSelectedDate(date);
    }
  }, [value]);

  // Dias em que o centro está fechado (além de domingos)
  const diasFechados = [
    "2026-04-04", // Sábado 4 de Abril 2026
  ];

  function disableDates(date) {
    // Bloquear domingos
    if (date.getDay() === 0) return true;
    // Bloquear dias específicos de fecho (usar data local, não UTC)
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return diasFechados.includes(`${y}-${m}-${d}`);
  }

  function _onChange(date) {
    if (date) {
      setSelectedDate(date);
      try {
        const ISODateString = date.toISOString();
        setValue(ISODateString);
      } catch (error) {
        setValue(date);
      }
    } else {
      setValue(date);
    }
  }

  const endDate = moment(new Date()).add(1, "year");
  return (
    <Grid container>
      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
        <KeyboardDatePicker
          {...field}
          inputVariant="outlined"
          InputProps={{
            readOnly: true
          }}
          okLabel="ok"
          locale="pt-PT"
          cancelLabel="Cancelar"
          shouldDisableDate={disableDates}
          id="date-picker-dialog"
          label="Data"
          format="dd/MM/yyyy"
          minDateMessage="Escolher uma data a partir de hoje"
          maxDate={endDate}
          disablePast
          value={selectedDate}
          onChange={_onChange}
          error={isError}
          invalidDateMessage={isError && error}
          helperText={isError && error}
        />
      </MuiPickersUtilsProvider>
    </Grid>
  );
}
